import { Layout, Panel, } from "@mcleod/components";

export abstract class AutogenLayoutStopProgress extends Layout {
    panelStopHeader: Panel;
}
